import styled from 'styled-components';

import {
  colorBlack900,
  colorGrey200,
  colorPrimary,
  colorPrimary200,
  colorPrimaryLighten95,
  colorWhite,
  fontFamilyPrimary,
} from 'styles';

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: 4px;
  max-width: 100%;
`;

const chipBase = `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 8px;
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  background: ${colorWhite};
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  color: ${colorBlack900};
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: ${colorPrimaryLighten95};
  }
`;

export const Tab = styled.a`
  ${chipBase}

  ${({ $active }) =>
    $active &&
    `
    background: ${colorPrimaryLighten95};
    border-color: ${colorPrimary200};
    color: ${colorPrimary};
  `}
`;

export const MoreSelectWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  height: 40px;

  & > div > button[aria-label='dropdown'] {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 8px;
    margin: 0;
    border: 1px solid ${colorGrey200};
    border-radius: 4px;
    background: ${colorWhite};
    outline: 0;
    cursor: pointer;

    &:hover {
      background: ${colorPrimaryLighten95};
      border-color: ${colorPrimary200};
    }

    & > svg {
      display: block;
      width: 12px;
      height: 8px;
      fill: ${colorBlack900};
      pointer-events: none;
    }
  }
`;
